// src/i18n/LanguageToggle.js
// The English / Español button. Drop it anywhere inside <LanguageProvider>.
import React from "react";
import { useLanguage } from "./LanguageContext";

const LanguageToggle = ({ style }) => {
  const { lang, toggleLang } = useLanguage();
  return (
    <button
      type="button"
      onClick={toggleLang}
      aria-label={lang === "en" ? "Cambiar a español" : "Switch to English"}
      style={{
        padding: "6px 12px",
        borderRadius: 8,
        // Solid navy + white text: readable everywhere, and the global
        // button styles (white text) can't wash it out.
        border: "1px solid #1e3a8a",
        background: "#1e3a8a",
        color: "#ffffff",
        boxShadow: "0 1px 2px rgba(15, 23, 42, 0.2)",
        cursor: "pointer",
        fontWeight: 700,
        width: "auto",
        ...style,
      }}
    >
      {lang === "en" ? "🌐 Español" : "🌐 English"}
    </button>
  );
};

export default LanguageToggle;
